export const environment = {
  production: false,
  defaultBrand: "xpeerai",
  brands: {
    xpeerai: {
      appUrl: "https://dev.xpeer.ai",
      brandName: "XPEER.AI",
      title: "XPeer.ai",
      favicon: "favicon.ico",
      logo: "assets/images/xpeer_logo1.png",
      logoHeight: "2.2vw",
      loginLogo: "assets/images/xpeer_logo.png",
    },
    aionos: {
      // appUrl: "https://delightful-pond-0d1956700.1.azurestaticapps.net",
      appUrl: "https://witty-cliff-01b33e500.7.azurestaticapps.net",
      brandName: "AIONOS",
      title: "AIONOS",
      favicon: "favicon1.ico",
      logo: "assets/images/aionos_logo.png",
      logoHeight: "1.9vw",
      loginLogo: "assets/images/aionos_logo.png",
    },
  },
  backendEndpoint: "https://dev.server.xpeer.ai",
  selenoidEndpoint: "dev.server.xpeer.ai",
  selenoidHubIp: "11.0.133.181",
  selenoidHubPort: 4445,
  serviceEndpointCheckUrl: "https://app.server.xpeer.ai:8080"
};
